var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-lc",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#65cfff",
    d: "M0 0h512v512H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m254.8 44.8 173.5 421.6-344 1L254.7 44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 103 150 362.6-297.5.8L255 103z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce00",
    d: "m254.8 256.1 173.5 210.8-344 .5 170.5-211.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLc);
export default __webpack_public_path__ + "static/media/lc.850505dc40354536a91bc2a0665a6d6b.svg";
export { ForwardRef as ReactComponent };